module.exports = __webpack_public_path__ + "img/enterprise-security-solutionsimg-15.c233c33f.png";